export class SideBarItemModel {
  DisplayName = "";
  DisplayNameLocalizationCode = "";
  Description = "";
  DescriptionLocalizationCode = "";
  Icon = "";
  RouterName = "";
  HasTopSeperator = "";
  SubItems = null;

  constructor({
    DisplayName,
    DisplayNameLocalizationCode,
    Description,
    DescriptionLocalizationCode,
    Icon,
    RouterName,
    HasTopSeperator,
    SubItems = null,
  }) {
    this.DisplayName = DisplayName;
    this.DisplayNameLocalizationCode = DisplayNameLocalizationCode;
    this.Description = Description;
    this.DescriptionLocalizationCode = DescriptionLocalizationCode;
    this.Icon = Icon;
    this.RouterName = RouterName;
    this.HasTopSeperator = HasTopSeperator;
    this.SubItems = SubItems;
  }
}

export class SideBarSubItemModel {
  DisplayName = "";
  DisplayNameLocalizationCode = "";
  Description = "";
  DescriptionLocalizationCode = "";
  Icon = "";
  RouterName = "";
  HasTopSeperator = "";
  PermissionCode = "";
  PermissionCodes = []

  constructor({ DisplayName, DisplayNameLocalizationCode, Description, DescriptionLocalizationCode, Icon, RouterName, HasTopSeperator, PermissionCode, PermissionCodes }) {
    this.DisplayName = DisplayName;
    this.DisplayNameLocalizationCode = DisplayNameLocalizationCode;
    this.Description = Description;
    this.DescriptionLocalizationCode = DescriptionLocalizationCode;
    this.Icon = Icon;
    this.RouterName = RouterName;
    this.HasTopSeperator = HasTopSeperator;
    this.PermissionCode = PermissionCode;
    this.PermissionCodes = PermissionCodes;
  }
}
